import { render } from "./flats-crm-items.vue?vue&type=template&id=2d4a06d2"
import script from "./flats-crm-items.vue?vue&type=script&lang=js"
export * from "./flats-crm-items.vue?vue&type=script&lang=js"

import "./flats-crm-items.vue?vue&type=style&index=0&id=2d4a06d2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__